<template>
    <div>
        <Head title="Contact" />
        <section class="relative z-10 overflow-hidden bg-primary h-[73px]"></section><!--end section-->
        <!-- Start Section-->
        <section class="relative w-full py-10 lg:py-20">
            <div class="container pb-5 cal_c">
                <div v-if="!confirmed && !schedule_confirm" class="flex justify-center flex-col md:flex-row e__t__calendar">
                    <div class="e__details flex flex-col w-full md:border-r">
                        <Link class="schedule-back-button relative" :href="this.route('schedule.user', user.username)">
                            <div class="arrow-wrap">
                                <span class="arrow-part-1"></span>
                                <span class="arrow-part-2"></span>
                                <span class="arrow-part-3"></span>
                            </div>
                        </Link>
                        <div class="e__user pt-3">{{ user.first_name }} {{ user.last_name }}</div>
                        <div class="e__e_type_name pt-2">{{ event_type.name }}</div>
                        <div class="e__time pt-5 flex items-center justify-start gap-2">
                            <icon name="clock" class="w-4 h-4" />
                            <div class="__time">{{ event_type.duration.replace('_',' ') }}</div>
                        </div>
                        <div class="desc pt-2" v-html="event_type.details" />
                    </div>
                    <div class="e__calendar flex flex-col items-center w-full">
                        <div class="flex flex-col md:flex-row gap-5">
                            <div class="calendar__area">
                                <div class="flex flex-col justify-start items-start pl-2">
                                    <small v-if="event">Reschedule Event</small>
                                    <div class="cal__title">Select a Date & Time</div>
                                </div>
                                <div class="calendar-month">
                                    <div class="calendar-month-header">
                                        <CalendarDateIndicator :selected-date="selectedDate" class="calendar-month-header-selected-month"/>
                                        <CalendarDateSelector :current-date="today" :selected-date="selectedDate" :disable-next="disableNext" :disable-previous="disablePrevious" @dateSelected="selectDate"/>
                                    </div>
                                    <CalendarWeekdays/>
                                    <ol class="days-grid">
                                        <CalendarMonthDayItem v-for="day in days" :key="day.date" :day="day" :is-today="day.date === today" :selected-day="day.date === selDay" :available-days="availableDays" @daySelected="selectDay"/>
                                    </ol>
                                </div>
                                <div class="flex justify-between items-center time__zone">
                                    <div class="cal__timezone">Time Zone</div>
                                    <td class="text-sm flex justify-center gap-3 text-gray-900 font-light whitespace-nowrap">
                                        <span class="font-bold">12h</span>
                                        <label class="flex toggle_swtich items-center cursor-pointer">
                                            <div class="relative">
                                                <input type="checkbox" class="sr-only" :checked="time_format === '24h'" @change="reformatTime($event.target.checked)" />
                                                <div class="w-7 h-2 bg-gray-400 rounded-full shadow-inner"></div>
                                                <div class="dot absolute w-4 h-4 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                                            </div>
                                        </label>
                                        <span class="font-bold">24h</span>
                                    </td>
                                </div>
                                <div class="pt-3 pb-8 w-full min-w-[320px] relative">
                                    <div class="flex w-full items-center form-select cursor-pointer select-none" @click="show_z_sel = !show_z_sel" :class="{'selected_ls':show_z_sel}">
                                        {{ form.timezone }} ({{ moment.tz(form.timezone).format(moment_format) }})
                                    </div>
                                    <input class="w-full p-2 border border-t-0 selected_ls border-b-gray-100 absolute" type="text" v-if="show_z_sel" placeholder="Search zone" v-model="typed_zone" @keyup="limitTimezone(typed_zone)" />
                                    <div v-if="show_z_sel" class=" select__dd top-[85px] zone__selector flex flex-col">
                                        <div class="flex justify-between zone__item select__dd__item" v-for="(timezone, ti) in filteredTimezone" :key="ti" @click="setTimezone(timezone)">
                                            <div class="zone__name">{{ timezone }}</div>
                                            <div class="zone__time">{{ moment.tz(timezone).format(moment_format) }}</div>
                                        </div>
                                        <div v-if="!filteredTimezone.length" class="select__dd__item">no timezone found!</div>
                                    </div>
                                </div>
                            </div>
                            <div class="day__slots" v-if="selectedDay">
                                <div class="slot__title">{{ selectedDay }}</div>
                                <div class="flex flex-col gap-2 slot__list">
                                    <div v-if="availableSlots.length" class="flex justify-center gap-2 slot__item" v-for="(slot, si) in availableSlots" :key="si">
                                        <button class="slot" @click="selectSlot(slot)">{{ slot }}</button>
                                        <button class="confirm" :class="{'visible': selectedSlot === slot}" @click="confirmSchedule(slot)">Confirm</button>
                                    </div>
                                    <div class="font-bold" v-else>
                                        No Slot Available
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="schedule_confirm" class="flex justify-center flex-col md:flex-row e__t__calendar schedule_confirm">
                    <div class="e__details flex flex-col w-full md:border-r">
                        <Link class="schedule-back-button relative" :href="this.route('event_type.schedule', {username: user.username, event_type: event_type.link})">
                            <div class="arrow-wrap">
                                <span class="arrow-part-1"></span>
                                <span class="arrow-part-2"></span>
                                <span class="arrow-part-3"></span>
                            </div>
                        </Link>
                        <div class="e__user pt-3">{{ user.first_name }} {{ user.last_name }}</div>
                        <div class="e__e_type_name pt-2">{{ event_type.name }}</div>
                        <div class="e__time pt-5 flex items-center justify-start gap-2">
                            <icon name="clock" class="w-4 h-4" />
                            <div class="__time">{{ event_type.duration.replace('_',' ') }}</div>
                        </div>
                        <div class="flex pt-3 gap-2 items-center date ">
                            <icon name="calendar" class="w-4 h-4" />
                            <div class="flex e__schedule_time">
                                {{ moment(form.start, ["h:mma"]).format(moment_format) }} - {{ moment(form.end, ["h:mma"]).format(moment_format) }}, {{ moment(form.day, 'YYYY-MM-DD').format('dddd, MMMM D, YYYY') }}
                            </div>
                        </div>
                        <div class="flex pt-3 gap-2 items-center t__zone">
                            <icon name="globe" class="w-4 h-4" />
                            <div class="t__zone">{{ form.timezone }}</div>
                        </div>
                        <div class="desc pt-3" v-html="event_type.details" />
                    </div>
                    <div class="e__calendar flex flex-col w-full">
                        <div class="text-left text-lg pb-4 font-bold">Enter Details</div>
                        <div class="flex flex-col w-full">
                            <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-3 w-full " label="Name" :is_required="true" />
                            <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-3 w-full " label="Email" :is_required="true" />
                        </div>
                        <div v-if="!show__guest" class="flex flex-col pb-4 w-full">
                            <button class="flex btn add_guest_btn" @click="show__guest = true">Add Guest</button>
                        </div>
                        <div v-if="show__guest" class="flex flex-col pt-2 pb-3 w-full">
                            <label class="form-label" for="guestEmail">Guest Email(s)</label>
                            <div class="border w-full guest__input__area" :class="{'on_hover':g_e_area}">
                                <div class="flex flex-wrap">
                                    <div class="sel_guest_email items-center border" v-for="(email, ei) in this.form.guest_emails" :key="ei">
                                        <span class="e__text">{{ email }}</span>
                                        <icon name="close" class="w-4 h-4 cursor-pointer" @click="removeFromGuestEmail(ei)" />
                                    </div>
                                </div>
                                <input id="guestEmail" class="form-input" type="email" @focus="g_e_area = true" @blur="addGuestEmail($event);g_e_area = false" @keyup="guestInputKeyUp($event)" />
                            </div>
                            <p class="pt-1">Notify up to 10 additional guests of the scheduled event.</p>
                        </div>
                        <div class="flex flex-col pt-2 pb-3 w-full">
                            <label class="form-label">Location *</label>
                            <div class="flex flex-col gap-4 w-full">
                                <div class="flex items-start justify-start gap-4 w-full" v-for="(event_location, ei) in event_locations" :key="ei">
                                    <input name="event_location_id" type="radio" :id="'e_l'+ei" v-model="form.event_location_id" :value="event_location.event_location_id">
                                    <label class="flex gap-2 items-start justify-start w-full" :for="'e_l'+ei">
                                        <img class="w-6 h-6" :src="event_location.event_location.image" />
                                        <div class="__phone flex flex-col justify-start gap-3 w-full">
                                            <div>{{ event_location.event_location.public_name || event_location.value }}</div>
                                            <div v-if="form.event_location_id === event_location.event_location_id" class="flex w-full">
                                                <div v-if="event_location.event_location.name.includes('Phone')" class="flex w-full">
                                                    <div class="text-xs	" v-if="event_location.value">{{ event_location.event_location.public_side }}</div>
                                                    <text-input v-else v-model="form.event_location_value" class="text-xs w-2/3" placeholder="eg. 01239487847"  />
                                                </div>
                                                <div v-else-if="event_location.event_location.public_field === 'text'" class="flex w-full">
                                                    <text-input v-if="event_location.event_location.name.includes('Phone')" v-model="form.event_location_value" class="text-xs w-2/3" placeholder="eg. 01239487847"  />
                                                    <text-input v-else class="text-xs w-2/3" v-model="form.event_location_value" placeholder=""  />
                                                </div>
                                                <div class="text-xs	" v-else-if="event_location.event_location.public_side">{{ event_location.event_location.public_side }}</div>
                                            </div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <textarea-input :rows="3" class="pt-1 pb-3 w-full" :label="__('Please share anything that will help prepare for our meeting.')"></textarea-input>
                        <button class="mt-1 btn schedule_e_btn" @click="scheduleEvent">{{ __('Schedule Event') }}</button>
                    </div>
                </div>
                <div v-if="confirmed" class="flex justify-center gap-5 flex-col e__t__calendar items-center confirmed">
<!--                    <Link class="schedule-back-button absolute top-2 left-2 md:top-[50px] md:left-[50px]" :href="this.route('event_type.schedule', {username: user.username, event_type: event_type.link})">-->
<!--                        <div class="arrow-wrap">-->
<!--                            <span class="arrow-part-1"></span>-->
<!--                            <span class="arrow-part-2"></span>-->
<!--                            <span class="arrow-part-3"></span>-->
<!--                        </div>-->
<!--                    </Link>-->
                    <div class="flex flex-col pt-10">
                        <h3 class="title">Schedule Confirmed!</h3>
                        <p>You are scheduled with {{ user.first_name }} {{ user.last_name }}.</p>
                    </div>
                    <div class="flex flex-col gap-3 event___info">
                        <div class="flex e__type items-center gap-2">
                            <div class="w-5 h-5 rounded-full color" :style="{'background-color': event_type.color}"></div>
                            <div class="t__name">{{ event_type.name }}</div>
                        </div>
                        <div class="flex gap-2 items-center date ">
                            <icon name="calendar" class="w-4 h-4 fill-indigo-600" />
                            <div class="flex e__schedule_time">
                                {{ moment(form.start, ["h:mma"]).format(moment_format) }} - {{ moment(form.end, ["h:mma"]).format(moment_format) }}, {{ moment(form.day, 'YYYY-MM-DD').format('dddd, MMMM D, YYYY') }}
                            </div>
                        </div>
                        <div class="flex gap-2 items-center t__zone">
                            <icon name="globe" class="w-4 h-4 fill-indigo-600" />
                            <div class="t__zone">{{ form.timezone }}</div>
                        </div>
                        <div class="flex gap-2 items-center t__zone">
                            <img class="w-6 h-6" :src="selected_event_location.event_location.image" />
                            <div class="t__zone">{{ form.event_location_value || selected_event_location.value || selected_event_location.event_location.public_name }}</div>
                        </div>
                        <div class="flex justify-center font-bold text-center">A confirmation has been sent to your email address.</div>
                    </div>
                    <div class="flex flex-col gap-4 pb-10 items-center justify-center pt-5">
                        <h2 class="justify-center text-center text-2xl font-light">Simple. Automated. Scheduling.</h2>
                        <a href="/register" class="btn-indigo border-r cursor-pointer">Signup For Free</a>
                        <h3 class="justify-center text-center text-xl font-light">Thank you for using Pro Schedule!</h3>
                    </div>
                </div>
            </div><!--end container-->
        </section>
        <!-- End Section-->

    </div>
</template>
<script>
// Calendar Import
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import CalendarMonthDayItem from "@/Pages/Calendar/CalendarMonthDayItem";
import CalendarDateIndicator from "@/Pages/Calendar/CalendarDateIndicator";
import CalendarDateSelector from "@/Pages/Calendar/CalendarDateSelector";
import CalendarWeekdays from "@/Pages/Calendar/CalendarWeekdays";

dayjs.extend(weekday);
dayjs.extend(weekOfYear);
// Calendar Import
import Layout from '@/Shared/Landing/Layout'
import Icon from '@/Shared/Icon'
import { Head, Link } from '@inertiajs/inertia-vue3'
import sanitizeHtml from "sanitize-html";
import moment_timezone from 'moment-timezone'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'

export default {
    layout: Layout,
    components: {
        Icon,
        Head,
        Link,
        TextInput,
        TextareaInput,
        CalendarMonthDayItem,
        CalendarDateIndicator,
        CalendarDateSelector,
        CalendarWeekdays

    },
    props: {
        user: Object,
        event_type: Object,
        event_locations: Object,
        event: Object,
    },
    data() {
        return {
            show__guest: false,
            page: null,
            schedule_confirm: false,
            selectedDate: dayjs(),
            disablePrevious: true,
            disableNext: false,
            show_z_sel: false,
            confirmed: false,
            g_e_area: false,
            typed_zone: '',
            availableDays: [],
            availableSlots: [],
            filteredTimezone: [],
            selectedDay: '',
            selDay: '',
            selectedSlot: '',
            selected_event_location: null,
            time_format: '12h',
            moment_format: 'h:mma',
            time_format_full: false,
            form: this.$inertia.form({
                timezone: this.event_type.timezone,
                start: '',
                end: '',
                day: '',
                email: '',
                name: '',
                guest_emails: [],
                event_type_id: this.event_type.id,
                event_location_id: null,
                event_location_value: '',
                question: ''
            })
        }
    },
    methods:{
        reformatTime(value){
            this.moment_format = !!value ? 'HH:mm': 'h:mma'
            if(!!value){
                this.availableSlots = this.availableSlots.map(slot=> this.moment(slot, ["h:mma"]).format(this.moment_format))
            }else{
                this.availableSlots = this.availableSlots.map(slot=> this.moment(slot, ["HH:mm"]).format(this.moment_format))
            }
        },
        removeFromGuestEmail(i){
            this.form.guest_emails.splice(i, 1)
        },
        addGuestEmail(e){
            const email = e.target.value
            const re = /\S+@\S+\.\S+/;
            if(typeof email === 'string' && re.test(email) && this.form.guest_emails.indexOf(email) === -1){
                this.form.guest_emails.push(email)
            }
            e.target.value = ''
        },
        guestInputKeyUp(e){
            if([32,188,13].includes(e.keyCode)){
                this.addGuestEmail(e)
            }
        },
        confirmSchedule(slot){
            this.form.start = this.moment(slot, this.moment_format).format('hh:mma')

            const startObj = this.moment(slot, this.moment_format).tz(this.form.timezone, true)
            const dur = this.event_type.duration.split('_')
            startObj.add(dur[0], Array.from(dur[1])[0])

            this.form.end = startObj.format('hh:mma')
            this.form.day = this.selDay
            this.schedule_confirm = true
        },
        setTimezone(zone){
            this.form.timezone = zone
            this.show_z_sel = false
            if(!!this.selDay){
                const time = this.moment().format('HH:mm:ss')
                const selDay = this.moment(this.selDay +' '+ time, 'YYYY-MM-DD HH:mm:ss')
                this.getDaySlot(selDay.tz(zone))
            }
        },
        validateEmail(email){
            return String(email)
                .toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
        },
        scheduleEvent(){
            if(!this.form.event_location_id){
                alert('Please select an event location!');
                return
            }
            if(!this.form.name){
                alert('Please input your name!');
                return
            }
            if(!this.validateEmail(this.form.email)){
                alert('The email is not validate!');
                return
            }
            this.selected_event_location = this.event_locations.filter(el=>el.event_location_id === this.form.event_location_id)[0]
            let url = this.route('event_type.calendar.schedule')
            if(!!this.event && this.event.id){
                url = this.route('event_type.calendar.reschedule', this.event.uid)
            }
            if(!this.form.event_location_value){
                if(!this.selected_event_location.value){
                    if(this.selected_event_location.event_location.name.includes('Phone')){
                        alert('Please type a phone number for the schedule!');
                    }else {
                        console.log(this.selected_event_location.value)
                        alert('The input field is required!');
                    }
                    return
                }
            }
            this.form.post(url, {
                onSuccess: () => {
                    let that = this
                    setTimeout(()=>{
                        that.selectDay(that.selDay)
                        that.schedule_confirm = false
                        that.confirmed = true
                        this.form.reset()
                    }, 0)
                },
                onError: (e) => {
                    this.selectDay(this.selDay)
                }
            })
        },
        limitTimezone(value){
            const pat =  new RegExp(value.toLowerCase())
            this.filteredTimezone = this.timezones.filter( t => pat.test(t.toLowerCase()))
        },
        sanitizeHtml : sanitizeHtml,
        strippedContent(html) {
            let regex = /(<([^>]+)>)/ig;
            return html.replace(regex, "");
        },
        getMonthSlot(moment){
            this.availableDays = []
            const date_range = JSON.parse(this.event_type.date_range)
            const hours = JSON.parse(this.event_type.hours)
            let startDate = moment.clone();
            let endMonth = moment.clone().endOf("month")
            let endDate = moment.clone().endOf("month");
            let available = false

            if(date_range.type === 'days' && moment.diff(this.event_type.updated_at, 'days') <= parseInt(date_range.days)){
                endDate = moment.add(parseInt(date_range.days), 'days')
                available = true
            }else if(date_range.type === 'range' && (moment.isSame(date_range.range[0], 'month') || moment.isSame(date_range.range[1], 'month'))){
                startDate = this.moment(date_range.range[0])
                endDate = this.moment(date_range.range[1])
                available = true
            }else if( date_range.type === 'future' ){
                available = true
            }
            if(available){
                let startingMoment = startDate;
                while(startingMoment <= endDate && startingMoment <= endMonth) {
                    const dayString = startingMoment.format('ddd').toLowerCase()
                    if(hours[dayString] && hours[dayString].length){
                        for (const hour of hours[dayString]) {
                            this.availableDays.push(startingMoment.clone().format("D"));
                        }
                    }
                    startingMoment.add(1, 'days');
                }
            }
            this.disableNext = !this.availableDays.length
        },
        async getDaySlot(moment){
            const dur = {'min': 'minutes', 'hrs': 'hours'};
            let startTime = false;
            let endTime = moment.clone().tz(this.event_type.timezone).endOf("day");
            const hours = JSON.parse(this.event_type.hours)
            const dayString = moment.clone().format('ddd').toLowerCase()
            const duration = this.event_type.duration.split('_')
            const beforeEvent = typeof this.event_type.after === 'string' ? this.event_type.before.split('_') : ''
            const afterEvent = typeof this.event_type.after === 'string' ? this.event_type.after.split('_') : ''
            let totalHours = hours[dayString]
            const existing_events = []
            let existing_slots = []

            await this.axios.post(this.route('event_type.calendar.slot'), {date: moment.format('YYYY-MM-DD'), user_id: this.user.id}).then((response) => {
                if(response.data){
                    existing_slots = response.data.existing_events
                }
            }).catch((error) => {
                console.log(error)
                this.availableSlots = []
            })

            for(const ee of existing_slots){
                existing_events.push({start: this.moment(ee.start, 'h:mma').tz(ee.timezone, true), end: this.moment(ee.end, 'h:mma').tz(ee.timezone, true)})
            }

            for (const override of hours.overrides) {
                if(this.moment().tz(this.event_type.timezone).format('YYYY-MM-DD') === override['day']){
                    totalHours = [].concat(totalHours, override['slots'])
                }
            }

            let slotHours = []

            if(totalHours.length){
                if(this.moment().tz(this.event_type.timezone).isSame(moment.tz(this.event_type.timezone), 'day')){
                    startTime = moment.clone().tz(this.event_type.timezone).add(30, 'minutes');
                    startTime.minutes(Math.floor(startTime.minutes() / 30) * 30);
                    if(!startTime.isSame(moment, 'day')){
                        startTime = startTime.endOf('day').subtract(1, 'minute')
                    }
                }
                for (const hour of totalHours) {
                    const hourStart = this.moment(hour.start, 'h:mma').tz(this.event_type.timezone, true)
                    endTime = this.moment(hour.end, 'h:mma').tz(this.event_type.timezone, true)
                    if(!startTime){
                        startTime = hourStart.clone()
                    }
                    while(startTime <= endTime){
                        if ((startTime.isBetween(hourStart, endTime) || startTime.isSame(hourStart)) && !this.including(startTime, existing_events)) {
                            slotHours.push(startTime.format('h:mma'))
                        }
                        startTime.add(duration[0], Array.from(duration[1])[0])
                        if(!!afterEvent){
                            const duration_text = dur[Array.from(afterEvent[1])[0]]
                            const duration_number = duration_text === 'hours' ? afterEvent[0]*60 : afterEvent[0];
                            startTime.tz(this.event_type.timezone).add(duration_number, duration_text);
                            startTime.minutes(Math.floor(startTime.minutes() / duration_number) * duration_number);
                            // startTime.add(afterEvent[0], Array.from(afterEvent[1])[0])
                        }
                    }
                }
            }

            this.availableSlots = []
            for (const hour of slotHours) {
                const slot = this.moment(hour, 'h:mma').clone().tz(this.event_type.timezone, true)
                this.availableSlots.push(slot.tz(this.form.timezone).format(this.moment_format))
            }

        },
        including(start, existing_events){
            let flag = false
            for(const ee of existing_events){
                if(start.isSameOrAfter(ee.start) && start.isBefore(ee.end)){
                    flag = true
                    break
                }
            }
            return flag
        },
        getWeekday(date) {
            return dayjs(date).weekday();
        },

        selectDate(newSelectedDate) {
            this.availableSlots = []
            this.selectedDate = newSelectedDate;
            if(this.moment().isBefore(this.moment(newSelectedDate.format('YYYY-MM-DD'), 'YYYY-MM-DD'), 'month')){
                this.getMonthSlot(this.moment(newSelectedDate.format("YYYY-MM"), 'YYYY-MM'))
                this.disablePrevious = false
            }else if(this.moment().isSame(this.moment(newSelectedDate.format('YYYY-MM-DD'), 'YYYY-MM-DD'), 'month')){
                this.getMonthSlot(this.moment())
                this.disablePrevious = true
            }
        },

        selectDay(day) {
            if(!!day){
                this.selDay = day
                const time = this.moment().format('HH:mm:ss')
                const selDay = this.moment(day +' '+ time, 'YYYY-MM-DD HH:mm:ss')
                this.getDaySlot(selDay)
                this.selectedDay = selDay.format('dddd, MMMM D')
            }
        },
        selectSlot(slot){
            this.selectedSlot = slot
        }
    },
    mounted() {
        this.getMonthSlot(this.moment())
    },
    computed: {
        days() {
            return [
                ...this.previousMonthDays,
                ...this.currentMonthDays,
                ...this.nextMonthDays
            ];
        },

        today() {
            return dayjs().format("YYYY-MM-DD");
        },

        month() {
            return Number(this.selectedDate.format("M"));
        },

        year() {
            return Number(this.selectedDate.format("YYYY"));
        },

        numberOfDaysInMonth() {
            return dayjs(this.selectedDate).daysInMonth();
        },
        currentMonthDays() {
            return [...Array(this.numberOfDaysInMonth)].map((day, index) => {
                return {
                    date: dayjs(`${this.year}-${this.month}-${index + 1}`).format(
                        "YYYY-MM-DD"
                    ),
                    isCurrentMonth: true
                };
            });
        },

        previousMonthDays() {
            const firstDayOfTheMonthWeekday = this.getWeekday(
                this.currentMonthDays[0].date
            );
            const previousMonth = dayjs(`${this.year}-${this.month}-01`).subtract(
                1,
                "month"
            );

            // Cover first day of the month being sunday (firstDayOfTheMonthWeekday === 0)
            const visibleNumberOfDaysFromPreviousMonth = firstDayOfTheMonthWeekday
                ? firstDayOfTheMonthWeekday - 1
                : 6;

            const previousMonthLastMondayDayOfMonth = dayjs(
                this.currentMonthDays[0].date
            )
                .subtract(visibleNumberOfDaysFromPreviousMonth, "day")
                .date();

            return [...Array(visibleNumberOfDaysFromPreviousMonth)].map(
                (day, index) => {
                    return {
                        date: dayjs(
                            `${previousMonth.year()}-${previousMonth.month() +
                            1}-${previousMonthLastMondayDayOfMonth + index}`
                        ).format("YYYY-MM-DD"),
                        isCurrentMonth: false
                    };
                }
            );
        },

        nextMonthDays() {
            const lastDayOfTheMonthWeekday = this.getWeekday(
                `${this.year}-${this.month}-${this.currentMonthDays.length}`
            );

            const nextMonth = dayjs(`${this.year}-${this.month}-01`).add(1, "month");

            const visibleNumberOfDaysFromNextMonth = lastDayOfTheMonthWeekday
                ? 7 - lastDayOfTheMonthWeekday
                : lastDayOfTheMonthWeekday;

            return [...Array(visibleNumberOfDaysFromNextMonth)].map((day, index) => {
                return {
                    date: dayjs(
                        `${nextMonth.year()}-${nextMonth.month() + 1}-${index + 1}`
                    ).format("YYYY-MM-DD"),
                    isCurrentMonth: false
                };
            });
        }
    },
    created() {
        this.moment = moment_timezone
        this.timezones = this.moment.tz.names()
        this.filteredTimezone = this.timezones
        this.form.timezone = this.moment.tz.guess()
        if(typeof this.event === 'object' && this.event){
            this.show__guest = true
            this.form.timezone = this.event.timezone
            this.form.email = this.event.email
            this.form.name = this.event.name
            this.form.guest_emails = this.event.guest_emails?JSON.parse(this.event.guest_emails):[]
            this.form.question = this.event.question??''
        }
        if(this.user.time_format){
            this.time_format = this.user.time_format
            this.moment_format = this.time_format === '24h' ? 'HH:mm': 'h:mma'
        }

    }
}
</script>
